import NavbarLayout from "./NavbarLayout";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { LoginFormValidation } from "../utils/formValidation";
import TextField from "../components/Reuseable/Forms/TextField";
import PasswordField from "../components/Reuseable/Forms/PasswordField";
import { LoginBackground, JwelleryLogo } from "../images";

type Props = {};

const LoginLayout = (props: Props) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<any>({
    resolver: yupResolver(LoginFormValidation),
  });

  // Queries
  const mutation = useMutation({
    mutationFn: (newLogin: any) => {
      return axios.post(
        "https://goldshop.dibsolutions.com.au/api/create-token/",
        newLogin
      );
    },
    onSuccess: (data) => {
      toast.success("Login Successful");
      localStorage.setItem("token", data?.data?.access);
      localStorage.setItem("refreshToken", data?.data?.refresh);
      navigate("/", { replace: true });
    },
    onError: (error: any) => {
      console.error("Login failed:", error?.response?.data?.detail);
      toast.error(error?.response?.data?.detail || "Login failed!");
    },
  });

  // Handle the login button click
  const handleLoginClick = (data: any) => {
    mutation.mutate({
      username: data.userName,
      password: data.password,
    });
  };
  return (
    <>
      <NavbarLayout screen={"login"} />
      <form onSubmit={handleSubmit((data: any) => handleLoginClick(data))}>
        <div
          className="w-full h-[95vh]"
          style={{
            backgroundImage: `url(${LoginBackground})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="w-full h-full flex flex-col justify-center items-center">
            <p className="w-full flex justify-center pb-9 text-[24px] font-semibold text-primary">
              Welcome to Jewellery POS
            </p>
            <div className="w-[660px] h-auto bg-white rounded flex justify-between px-8 py-20 ">
              <img
                src={JwelleryLogo}
                alt="JwelleryLogo"
                className="w-48 h-32 m-auto"
              />
              <div className="flex flex-col items-center pt-5 space-y-3">
                <TextField
                  register={register}
                  name={"userName"}
                  placeholder="John"
                  label="Username"
                  errors={errors?.userName}
                />
                <PasswordField
                  register={register}
                  name={"password"}
                  placeholder="*******"
                  label="Password"
                  errors={errors?.password}
                />
                <button
                  type="submit"
                  className="bg-[#4338CA] hover:bg-purple-700 w-full text-white p-2 rounded font-bold"
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default LoginLayout;
